import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ExposureDashboardDefaultFilter } from '@views/DashboardOverviewPage/constants';
import { APP_PATHS, PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/overview/')({
  validateSearch: zodValidator(withDefaults(schema.OVERVIEW, ExposureDashboardDefaultFilter)),
  search: {
    middlewares: [stripSearchParams(ExposureDashboardDefaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      app: APP_PATHS.VULNERABILITIES,
      path: PAGE_PATHS.OVERVIEW,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
